export const StuffLogo = (props) => (
  <svg
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="20"
    viewBox="0 0 56 20"
    fill="none"
  >
    <path
      d="M47.8739 1.73079V0.374603H45.8317C43.2243 0.374603 40.9772 1.70224 40.9772 4.97852V6.20623H38.9351V7.56242H42.454V5.08558C42.454 2.4303 44.1923 1.73079 45.8529 1.73079H47.8739Z"
      fill="#20242C"
    />
    <path
      d="M36.2781 13.9794C36.2781 16.8702 34.5892 18.5333 31.7274 18.5333C28.8373 18.5333 27.1555 16.8702 27.1555 13.9794V7.47677L27.6926 6.92716V6.1991H25.6716V13.9223C25.6716 17.9551 28.1236 19.8824 31.7274 19.8824C35.3029 19.8824 37.7549 17.9551 37.7549 13.9223V6.1991H36.271V13.9794H36.2781Z"
      fill="#20242C"
    />
    <path
      d="M51.6331 19.6254H53.117V10.025H56.0071V8.66879H51.6401V19.6254H51.6331Z"
      fill="#20242C"
    />
    <path
      d="M39.6487 8.12631H38.9351V10.025H40.9772V19.6254H42.4611V8.67593H40.1858L39.6487 8.12631Z"
      fill="#20242C"
    />
    <path
      d="M43.634 19.6254H45.1179V10.025H48.9761V19.6254H50.46V8.67593H43.6411V19.6254H43.634Z"
      fill="#20242C"
    />
    <path
      d="M31.7275 17.4127C33.8756 17.4127 35.0981 16.1136 35.0981 14.0079V7.47677L35.6351 6.92716V6.1991H33.6142V14.0579C33.6142 15.3855 32.9994 16.0636 31.7204 16.0636C30.4414 16.0636 29.8054 15.3855 29.8054 14.0579V6.1991H28.3215V14.0008C28.3286 16.085 29.5581 17.4127 31.7275 17.4127Z"
      fill="#20242C"
    />
    <path
      d="M53.8306 0.374603C51.2232 0.374603 48.9761 1.70224 48.9761 4.97852V6.19909H45.1179V5.24262C45.1179 4.46459 45.3511 4.20049 46.1637 4.20049H47.8738V2.8443H46.0578C44.3972 2.8443 43.634 3.60091 43.634 5.21407V7.55528H50.453V5.08558C50.453 2.4303 52.1913 1.73079 53.8518 1.73079H56V0.374603H53.8306Z"
      fill="#20242C"
    />
    <path
      d="M51.6331 5.21407V7.55528H54.7493L55.2863 8.09776H56V6.19909H53.1099V5.24262C53.1099 4.46459 53.3431 4.20049 54.1557 4.20049H55.9929V2.8443H54.0568C52.3962 2.8443 51.6331 3.60091 51.6331 5.21407Z"
      fill="#20242C"
    />
    <path
      d="M5.67427 11.6667L8.25345 12.2163C9.86455 12.5518 10.4722 13.1228 10.4722 14.1435C10.4722 15.5211 9.39818 16.1707 7.48322 16.1707C5.44108 16.1707 4.36701 15.4426 4.19035 13.9365H2.70644C3.01029 16.5418 4.90404 17.4769 7.46203 17.4769C10.0907 17.4769 11.9562 16.4919 11.9562 14.0721C11.9562 12.0664 10.656 11.2598 8.66329 10.8458L5.95692 10.2748C3.12335 9.67523 1.89382 8.24766 1.89382 5.87789C1.89382 3.14409 3.68158 1.43101 7.28537 1.43101C10.1189 1.43101 12.0622 2.63017 12.7264 4.86432L12.2176 5.49245C12.2741 5.73513 12.3165 5.97782 12.3448 6.22051H14.4364C14.1538 2.58734 11.7018 0.117645 7.2783 0.117645C3.29294 0.117645 0.409912 1.98776 0.409912 5.86361C0.409912 9.26837 2.43086 10.9886 5.67427 11.6667Z"
      fill="#20242C"
    />
    <path
      d="M18.3439 2.48029H16.86V6.19911H14.8179V7.5553H18.3439V2.48029Z"
      fill="#20242C"
    />
    <path
      d="M9.47584 8.36187L6.69173 7.79084C5.15836 7.47678 4.60013 6.82723 4.60013 5.76369C4.60013 4.56453 5.59647 3.83647 7.2853 3.83647C8.97413 3.83647 10.0694 4.64305 10.2461 6.20624H11.73C11.4968 3.62948 9.56063 2.53738 7.2853 2.53738C4.9605 2.53738 3.12328 3.52241 3.12328 5.84221C3.12328 7.71232 4.29628 8.73304 6.36669 9.16845L9.07306 9.73947C11.7794 10.3105 13.1856 11.5097 13.1856 13.9294C13.1856 16.7917 11.0657 18.5833 7.38423 18.5833C4.60013 18.5833 2.48025 17.4626 1.7383 15.2784L2.24707 14.6575C2.19054 14.4148 2.14814 14.1721 2.11987 13.9294H0C0.176656 17.7838 3.03849 19.8895 7.38423 19.8895C11.7512 19.8895 14.6695 17.8338 14.6695 13.908C14.6625 10.7031 12.698 9.01141 9.47584 8.36187Z"
      fill="#20242C"
    />
    <path
      d="M21.001 2.48029H19.5171V7.5553H23.2481L23.7851 8.09777H24.4988V6.1991H21.001V2.48029Z"
      fill="#20242C"
    />
    <path
      d="M18.3439 15.1V8.67593H16.0686L15.5316 8.12631H14.8179V10.0321H16.86V15.3141C16.86 18.6975 18.8527 19.6325 21.3541 19.6325H24.4916V18.2763H21.6297C19.7996 18.2692 18.3439 17.6982 18.3439 15.1Z"
      fill="#20242C"
    />
    <path
      d="M19.5171 14.9715C19.5171 16.7132 20.2802 17.1557 21.8136 17.1557H24.4988V15.7995H21.9196C21.1777 15.7995 21.001 15.4854 21.001 14.7859V10.0321H24.4988V8.67593H19.5171V14.9715Z"
      fill="#20242C"
    />
  </svg>
);
